const addActionTypePrefix = (actionType, prefix) => `${prefix}/${actionType}`;

export { addActionTypePrefix };
